<template>
  <div>
    <a-card class="card">
      <div class="trend-content">
        <SearchView
          :renderItem="SEARCH_SCHEMA"
          :isExpandShowOrNot="false"
          :initialValues="initSearchForm"
          formLayout="inline"
          @fetchSearch="handleSearch"
          :mediaLayout="{ sm: 24, md: 12, lg: 12 }"
        ></SearchView>
        <!-- </a-card>
    <a-card title="信用趋势" class="card"> -->
        <Chart
          class="card"
          :data-source="(statistics && statistics.trend) || []"
          id="chart"
        >
          <template v-if="statistics">
            <div style="display: inline-block; vertical-align: middle">
              <h4>近期最高值</h4>
              <div>
                已生效限额: {{ statistics.maxLimit.time }},
                {{ statistics.maxLimit.amount | formatAmount }}元
              </div>
              <div>
                当前有效额度: {{ statistics.maxValid.time }},
                {{ statistics.maxValid.amount | formatAmount }}元
              </div>
              <div>
                保险额度: {{ statistics.maxInsurance.time }},
                {{ statistics.maxInsurance.amount | formatAmount }}元
              </div>
              <div>
                担保额度: {{ statistics.maxAssurance.time }},
                {{ statistics.maxAssurance.amount | formatAmount }}元
              </div>
              <div>
                每日限额条件: {{ statistics.maxLimitCondition.time }},
                {{ statistics.maxLimitCondition.amount | formatAmount }}元
              </div>
              <div>
                未生效限额: {{ statistics.maxNotStartedLimit.time }},
                {{ statistics.maxNotStartedLimit.amount | formatAmount }}元
              </div>
            </div>
          </template>
        </Chart>

        <!-- </a-card>
    <a-card> -->
        <a-divider />
        <div class="text-right">
          <a-button type="primary" icon="download" @click="exportFile">
            下载报表
          </a-button>
        </div>
        <table-view
          id="table"
          :data="tableData"
          :columns="columns"
          :pagination="pageData"
          :loading="tableLoading"
          :scroll="SCROLL"
          @handlePagination="handlePagination"
          rowKey="time"
        >
          <template v-slot:limitAmount="{ tableRow }">
            <span>
              {{ tableRow.limitAmount | formatAmount }}
            </span>
          </template>
          <template v-slot:validAmount="{ tableRow }">
            <span>
              {{ tableRow.validAmount | formatAmount }}
            </span>
          </template>
          <template v-slot:insuranceAmount="{ tableRow }">
            <span>
              {{ tableRow.insuranceAmount | formatAmount }}
            </span>
          </template>
          <template v-slot:assuranceAmount="{ tableRow }">
            <span>
              {{ tableRow.assuranceAmount | formatAmount }}
            </span>
          </template>
          <template v-slot:limitConditionAmount="{ tableRow }">
            <span>
              {{ tableRow.limitConditionAmount | formatAmount }}
            </span>
          </template>
          <template v-slot:notStartedLimitAmount="{ tableRow }">
            <span>
              {{ tableRow.notStartedLimitAmount | formatAmount }}
            </span>
          </template>
        </table-view>
      </div>
    </a-card>

    <a-anchor
      :target-offset="targetOffset"
      :affix="true"
      class="anchor-wrap"
      @click="handleAnchorClick"
    >
      <a-anchor-link href="#chart" title="趋势图" />
      <a-anchor-link href="#table" title="表格" />
    </a-anchor>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import Chart from './components/Chart'
import cloneDeep from 'lodash/cloneDeep'
import { formatParamDate } from 'utils/util'
import { getTableData, getTrendData, download } from './api'
import moment from 'moment'

export default {
  name: 'trend',
  data() {
    const lastYear = moment().subtract(1, 'year')
    const companyCode = this.$store.getters['app/company'].code
    //  赋初始值，开始日期默认前一年，结束日期默认当天
    const initSearchForm = {
      rangeDate: [lastYear, moment()],
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      companyCode,
      SEARCH_SCHEMA: [
        {
          itemName: 'rangeDate',
          label: '起始日期',
          type: 'rangePicker',
          format: 'YYYY-MM-DD',
          allowClear: true,
          disabledDate: this.disabledDate,
        },
      ],
      initSearchForm,
      searchForm,
      tableLoading: false,
      tableData: [],
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          fixed: 'left',
        },
        {
          title: '日期',
          dataIndex: 'time',
          width: 150,
        },
        {
          title: '已生效限额(元)',
          dataIndex: 'limitAmount',
          scopedSlots: { customRender: 'limitAmount' },
          width: 200,
        },
        {
          title: '当前有效额度(元)',
          scopedSlots: { customRender: 'validAmount' },
          dataIndex: 'validAmount',
          width: 200,
        },
        {
          title: '保险额度(元)',
          scopedSlots: { customRender: 'insuranceAmount' },
          dataIndex: 'insuranceAmount',
          width: 200,
        },
        {
          title: '担保额度(元)',
          scopedSlots: { customRender: 'assuranceAmount' },
          dataIndex: 'assuranceAmount',
          width: 200,
        },
        {
          title: '每日限额条件(元)',
          scopedSlots: { customRender: 'limitConditionAmount' },
          dataIndex: 'limitConditionAmount',
          width: 200,
        },
        {
          title: '未生效限额(元)',
          scopedSlots: { customRender: 'notStartedLimitAmount' },
          dataIndex: 'notStartedLimitAmount',
          width: 200,
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      SCROLL: { x: 1050 },
      statistics: null,
      targetOffset: null,
    }
  },
  created() {
    this._getTableData(this.initSearchForm)
    this._getStatistics(this.initSearchForm)
  },
  mounted() {
    this.targetOffset = window.innerHeight / 2
  },
  methods: {
    moment,
    // 不可选择的日期
    disabledDate(current) {
      return current && current > moment().endOf('day')
    },
    handleSearch(data) {
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getTableData(data)
      this._getStatistics(data)
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getTableData(this.searchForm)
    },
    getSearchParam(searchForm) {
      let search = cloneDeep(searchForm)
      search = formatParamDate(search, search.rangeDate)
      delete search.rangeDate
      return { ...search, companyCode: this.companyCode }
    },
    async _getStatistics(searchForm) {
      this.charLoading = true
      const params = this.getSearchParam(searchForm)
      try {
        const { data } = await getTrendData(params)
        this.statistics = data
      } catch (error) {
        console.error(error)
      }
    },
    async _getTableData(searchForm) {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const search = this.getSearchParam(searchForm)
      const formData = {
        ...search,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getTableData(formData)
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    exportFile() {
      const params = this.getSearchParam(this.searchForm)
      download(params)
    },

    handleAnchorClick(e, link) {
      e.preventDefault()
      this.$router.push({
        name: 'trend',
        params: { mod: link.href.slice(1, 5) },
      })
    },
  },
  components: {
    SearchView,
    TableView,
    Chart,
  },
}
</script>
<style lang="less" scoped>
.trend-content {
  width: 90%;
  margin: 0 0 40px 40px;
}
/deep/ .anchor-wrap {
  position: fixed;
  right: 2%;
  top: 400px;
}
</style>
